import {
  SET_VIDEO_LOADING,
  SET_VIDEO_ERROR,
  SET_VIDEO,
  SET_MY_VIDEO
} from "../actionTypes/index";
import { baseUrl } from "../../apis/baseUrl";
import { errorAlert } from "../../helpers/alerts";

const setVideo = (payload) => {
  return { type: SET_VIDEO, payload };
};

const setMyVideo = (payload) => {
  return { type: SET_MY_VIDEO, payload };
}

const setVideoError = (payload) => {
  return { type: SET_VIDEO_ERROR, payload };
};

const setVideoLoading = (payload) => {
  return { type: SET_VIDEO_LOADING, payload };
};

export const getAllVideo = () => {
  return async (dispatch, getState) => {
    dispatch(setVideoLoading(true));
    dispatch(setVideoError(null));
    try {
      // const { data } = await baseUrl.get("/video/all", {
      //   headers: { access_token: localStorage.access_token },
      // });
      const data = [
        {
          "id" : 1,
          "name" : "Makko Giri",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Suburi",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 2,
          "name" : "Kesa Giri",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Suburi",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 3,
          "name" : "Gyaku Kesa Giri",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Suburi",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 4,
          "name" : "Yoko Ichi Monji",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Suburi",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 5,
          "name" : "Uke Tome",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Uke",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 6,
          "name" : "Uke Nagashi",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Uke",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 7,
          "name" : "Okuri Ashi",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Ashisabaki",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 8,
          "name" : "Hiraki Ashi",
          "level" : "Candidate",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Ashisabaki",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 9,
          "name" : "Kihon Ichi",
          "level" : "Mukyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Kihon Kata",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 10,
          "name" : "Kihon Ni",
          "level" : "Mukyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Kihon Kata",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 11,
          "name" : "Shin",
          "level" : "Mukyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Yo",
          "style" : "Zagi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 12,
          "name" : "Munazukushi",
          "level" : "Mukyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ou",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 13,
          "name" : "Enyo",
          "level" : "Gokyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ou",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 14,
          "name" : "Ren",
          "level" : "Gokyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Yo",
          "style" : "Zagi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 15,
          "name" : "Ryouguruma",
          "level" : "Yonkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ou",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 16,
          "name" : "Sa",
          "level" : "Sankyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Yo",
          "style" : "Zagi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 17,
          "name" : "Yuu",
          "level" : "Sankyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Yo",
          "style" : "Zagi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 18,
          "name" : "No Okuri",
          "level" : "Sankyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ou",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 19,
          "name" : "Sha",
          "level" : "Nikyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Yo",
          "style" : "Zagi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 20,
          "name" : "Gyokkou",
          "level" : "Nikyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ou",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 21,
          "name" : "Suigetsu",
          "level" : "Ikkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ka",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 22,
          "name" : "Inchuyo",
          "level" : "Ikkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ka",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 23,
          "name" : "Yochuin",
          "level" : "Ikkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Go-Ka",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 24,
          "name" : "Mae Goshi",
          "level" : "Ikkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Hashiri Gakari",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        },
        {
          "id" : 25,
          "name" : "Musou Gaeshi",
          "level" : "Ikkyu",
          "link" : "https:/www.youtube.com/embed/FXuL5ka2ik0",
          "group" : "Hashiri Gakari",
          "style" : "Tachi",
          "createdAt" : "2024-08-07T08:40:13.501Z",
          "updatedAt" : "2024-08-07T08:40:13.501Z"
        }
      ];
      dispatch(setVideo(data));
    } catch (err) {
      dispatch(setVideoError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setVideoLoading(false));
    }
  };
};

export const getMyVideo = () => {
  return async (dispatch, getState) => {
    dispatch(setVideoLoading(true));
    dispatch(setVideoError(null));
    try {
      const { data } = await baseUrl.get("/video/lesson", {
        headers: { access_token: localStorage.access_token },
      });
      dispatch(setMyVideo(data));
    } catch (err) {
      dispatch(setVideoError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setVideoLoading(false));
    }
  };
};

export const addVideo = (newVideoForm) => {
  return async (dispatch, getState) => {
    dispatch(setVideoLoading(true));
    dispatch(setVideoError(null));
    try {
      // await baseUrl.post("/video/add", newVideoForm, {
      //   headers: { access_token: localStorage.access_token },
      // });
      // dispatch(getAllVideo());
    } catch (err) {
      dispatch(setVideoError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setVideoLoading(false));
    }
  };
};

export const editVideo = (id, editVideoForm) => {
  return async (dispatch, getState) => {
    dispatch(setVideoLoading(true));
    dispatch(setVideoError(null));
    try {
      // await baseUrl.put(`/video/edit/${id}`, editVideoForm, {
      //   headers: { access_token: localStorage.access_token },
      // });
      // dispatch(getAllVideo());
    } catch (err) {
      dispatch(setVideoError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setVideoLoading(false));
    }
  };
};
